//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from "@/lib/vuexMixin";

export default {
  name: "HeaderAdmin",
  mixins: [vuexMixin],
  props: {
    titlePage: {
      type: String,
      default: "",
    },
    breadcrumbsProp: {
      type: Array,
      default() {
        return [];
      },
    },
    objApiConsumed: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  computed: {
    text() {
      return this.user.name;
    },
    nomeUsuario() {
      return !this.user && !this.user.name
        ? ""
        : this.user.name.substring(0, 2);
    },
  },

  data() {
    return {
      rounded: true,
      expand: false,
      teste: null,
      breadcrumbsAtualizado: [],
    };
  },
  watch: {
    breadcrumbsProp: {
      handler(navArray) {
        this.breadcrumbsAtualizado = [...navArray];
      },
      immediate: true,
    },
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    styleDisabled(disabled) {
      // this.primaryVx
      // return !disabled ? `color: #eaeaea; cursor: pointer; ` : ``;
      return !disabled ? `color:${this.primaryVx}; cursor: pointer; ` : ``;
    },
  },
};
